import * as types from '../../constants/app/basicConstants';

export const basicMissionListRequest = ({
  page,
  pageLength,
  callback,
  error,
}) => ({
  type: types.BASIC_MISSION_LIST_REQUEST,
  page,
  pageLength,
  callback,
  error,
});

export const basicMissionCreateRequest = ({
  beginAt,
  endAt,
  conditionAt,
  initialPer,
  initialXper,
  dailyData,
  achievementData,
  walletNo,
  depositTransactionStatus,
  callback,
  error,
}) => ({
  type: types.BASIC_MISSION_CREATE_REQUEST,
  beginAt,
  endAt,
  conditionAt,
  initialPer,
  initialXper,
  dailyData,
  achievementData,
  walletNo,
  depositTransactionStatus,
  callback,
  error,
});

export const basicMissionInfoDetailRequest = ({
  missionNo,
  callback,
  error,
}) => ({
  type: types.BASIC_MISSION_INFO_DETAIL_REQUEST,
  missionNo,
  callback,
  error,
});

export const basicMissionInfoDepositRequest = ({
  missionNo,
  tokenType,
  transactionHash,
  callback,
  error,
}) => ({
  type: types.BASIC_MISSION_INFO_DEPOSIT_REQUEST,
  missionNo,
  tokenType,
  transactionHash,
  callback,
  error,
});

export const basicMissionInfoAddBudgetRequest = ({
  missionNo,
  addPer,
  addXper,
  transactionHash,
  callback,
  error,
}) => ({
  type: types.BASIC_MISSION_INFO_ADD_BUDGET_REQUEST,
  missionNo,
  addPer,
  addXper,
  transactionHash,
  callback,
  error,
});

export const basicMissionInfoUpdateRequest = ({
  missionNo,
  beginAt,
  endAt,
  conditionAt,
  dailyData,
  achievementData,
  callback,
  error,
}) => ({
  type: types.BASIC_MISSION_INFO_UPDATE_REQUEST,
  missionNo,
  beginAt,
  endAt,
  conditionAt,
  dailyData,
  achievementData,
  callback,
  error,
});

export const basicMissionInfoRemoveRequest = ({
  missionNo,
  callback,
  error,
}) => ({
  type: types.BASIC_MISSION_INFO_REMOVE_REQUEST,
  missionNo,
  callback,
  error,
});

export const basicReferralAccountInfoListRequest = ({
    page,
    pageLength,
    accountNo,
    inviteCode,
    callback,
    error,
  }) => ({
    type: types.BASIC_REFERRAL_ACCOUNT_INFO_LIST_REQUEST,
    page,
    pageLength,
    accountNo,
    inviteCode,
    callback,
    error,
});

export const basicReferralInvitedUserListRequest = ({
    page,
    pageLength,
    inviterAccountNo,
    invitedAccountNo,
    callback,
    error,
  }) => ({
  type: types.BASIC_REFERRAL_INVITED_USER_LIST_REQUEST,
  page,
  pageLength,
  inviterAccountNo,
  invitedAccountNo,
  callback,
  error,
});
export const basicReferralGradeRewardLogListRequest = ({
    page,
    pageLength,
    beginDate,
    endDate,
    accountNo,
    contentNo,
    callback,
    error,
  }) => ({
  type: types.BASIC_REFERRAL_GRADE_REWARD_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  contentNo,
  callback,
  error,
});

export const basicReferralPointLogListRequest = ({
    page,
    pageLength,
    beginDate,
    endDate,
    accountNo,
    callback,
    error,
  }) => ({
  type: types.BASIC_REFERRAL_POINT_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  callback,
  error,
});




